import httpInstances from '@/api/axiosInstance';
import { Products } from '@/pages/Subscription/types/ManageSubscription';

export async function getProducts() {
  const response = await httpInstances.axiosGoInstance.get('/subscriptions/products');
  const products = response.data as Products;
  return products.sort((a, b) => {
    const orderA = Number(a.metadata.gx_go_webpage_order) || 0;
    const orderB = Number(b.metadata.gx_go_webpage_order) || 0;
    return orderA - orderB;
  });
}
